import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from '../_services/AdminService.service';
import { ActivatedRoute } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';
import { AuthServiceService } from '../_services/AuthService.service';
import { SubscriptionForRegister } from '../_models/SubscriptionForRegister';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-photosapi',
  templateUrl: './photosapi.component.html',
  styleUrls: ['./photosapi.component.css']
})
export class PhotosapiComponent implements OnInit {

  apiInfo: any;
  projects: any = new Array<any>();
  currentSubscription: SubscriptionForRegister = new SubscriptionForRegister();
  currentApiKey: any;
  currentEmailConfig: any;

  jwtHelper = new JwtHelperService();
  decodedToken: any;


  constructor(private _adminService: AdminServiceService, private _route: ActivatedRoute, 
    private _alertify: AlertifyService, private _authService: AuthServiceService) { }

  ngOnInit() {
    this._route.queryParams.subscribe(params => {
      this.loadApiInfo(params["id"]);
    });    
  
    this.loadProjects();
  }

  private loadApiInfo(apiId) {
    this._adminService.getApiDetails(apiId).subscribe(details => {
      this.apiInfo = details;
    }, error => {
      this._alertify.error(error);
    });
  }

  onAddNewProject() {
    this.projects.push(new SubscriptionForRegister());
  }

  loadProjects() {
    this._adminService.getPhotosSubscriptionsByUserId(this._authService.decodedToken.nameid).subscribe(data => {
      this.projects = data;
    });
  }
  
}
